const dev = {
  cognito: {
    region: "us-west-2",
    userPoolId: "us-west-2_PS5xE5ypI",
    identityPoolId: "us-west-2:b5492424-2538-494f-9e30-b34d9971457f",
    userPoolWebClientId: "2k0jv7k6m7fdann2em1ddc8pqc",
  },
  appSync: {
    aws_appsync_graphqlEndpoint:
      "https://4airussapnew3ecuri64ltjklq.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AWS_IAM",
  },
  pinpoint: {
    appId: "754631af126a4a18a0a11645ee7cfb1f",
    region: "us-west-2",
  },
  bugsnag: {
    id: "29aaa5602246ce57752f3b59457606bf",
  },
  geolocation: {
    url:
      "https://6cbxzuvc91.execute-api.us-west-2.amazonaws.com/dev/geolocation-update",
  },
  s3: {
    bucket: "kirs-media-us-west-2-992649602691",
    spBucket: "service-provider-logos-us-west-2-992649602691",
    reportsBucket: "kirs-reports-us-west-2-992649602691",
  },
  iot: {
    endpoint: "wss://a3tyns6izotbcq-ats.iot.us-west-2.amazonaws.com/mqtt",
  },
  algolia: {
    indecies: {
      shiftTemplates: "dev_shiftTemplates",
    },
  },
  googleMaps: {
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  pusher: {
    key: "12e4b9f131cae3a4cc27",
    cluster: "us3",
  },
  mixpanel: {
    token: "2170044ee355c3121b5ece55a835ddab",
  },
};

const staging = {
  cognito: {
    region: "us-west-2",
    userPoolId: "us-west-2_nxax6HuRK",
    identityPoolId: "us-west-2:96ffd213-b977-4a7b-b63c-e3477451f213",
    userPoolWebClientId: "5k9f02ohf3vb141vrjo6n6me1",
  },
  appSync: {
    aws_appsync_graphqlEndpoint:
      "https://ls35i3b4e5axperlcxfoguqlhm.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AWS_IAM",
  },
  pinpoint: {
    appId: "10e1f7dce9aa4b5a8ff12c7b82476670",
    region: "us-west-2",
  },
  bugsnag: {
    id: "29aaa5602246ce57752f3b59457606bf",
  },
  geolocation: {
    url:
      "https://m44a4j4mt9.execute-api.us-west-2.amazonaws.com/staging/geolocation-update",
  },
  s3: {
    bucket: "kirs-media-us-west-2-119423719352",
    spBucket: "service-provider-logos-us-west-2-119423719352",
    reportsBucket: "kirs-reports-us-west-2-119423719352",
  },
  iot: {
    endpoint: "wss://a3pm65wkurv6gi-ats.iot.us-west-2.amazonaws.com/mqtt",
  },
  algolia: {
    indecies: {
      shiftTemplates: "staging_shiftTemplates",
    },
  },
  googleMaps: {
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  pusher: {
    key: "e71a9e0e3972a62e4ca7",
    cluster: "us3",
  },
  mixpanel: {
    token: "19ef87d5fb605b8f1c80cf8ff087ba68",
  },
};

const prod = {
  cognito: {
    region: "us-west-2",
    userPoolId: "us-west-2_KgyplWudK",
    identityPoolId: "us-west-2:2b0e523d-3d5f-4c72-94de-a15ef8e6f0b7",
    userPoolWebClientId: "23cubum5ulrfq65pbarehsbled",
  },
  appSync: {
    aws_appsync_graphqlEndpoint:
      "https://l6kyj37nnfglle3jsdjg5rk5na.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AWS_IAM",
  },
  pinpoint: {
    appId: "12ec1b5824084e76aaecaa51ce435e87",
    region: "us-west-2",
  },
  bugsnag: {
    id: "29aaa5602246ce57752f3b59457606bf",
  },
  geolocation: {
    url:
      "https://k40p6p43fd.execute-api.us-west-2.amazonaws.com/prod/geolocation-update",
  },
  s3: {
    bucket: "kirs-media-us-west-2-285716431146",
    spBucket: "service-provider-logos-us-west-2-285716431146",
    reportsBucket: "kirs-reports-us-west-2-285716431146",
  },
  iot: {
    endpoint: "wss://a2ixbfjfbe68c1-ats.iot.us-west-2.amazonaws.com/mqtt",
  },
  algolia: {
    indecies: {
      shiftTemplates: "prod_shiftTemplates",
    },
  },
  googleMaps: {
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  pusher: {
    key: "69a73d2c9b58dfa04d72",
    cluster: "us3",
  },
  mixpanel: {
    token: "94382b342fb7308d748105675e452560",
  },
};

let config = dev;

// DO NOT CHANGE THESE
if (process.env.REACT_APP_STAGE === "prod") config = prod;
else if (process.env.REACT_APP_STAGE === "staging") config = staging;
else if (process.env.REACT_APP_STAGE === "dev") config = dev;

export default config;
